import SidePanel from '@design/objects/sidePanel/twig/assets'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import * as LayerManager from 'assets/core/js/module/layerManager'
import * as PanelManager from 'assets/core/js/module/panelManager'
import type { SidePanelConfig as BaseSidePanelConfig } from '@design/objects/sidePanel/twig/assets'

export type SidePanelType = SidePanel
export type SidePanelConfig = BaseSidePanelConfig

export default (element: string | HTMLElement, config?: SidePanelConfig): SidePanel => {
  const shouldAttachElementProperty = element != null && typeof element === 'object'

  if (!config) {
    config = {}
  }

  let onOpen: SidePanelConfig['onOpen'] | null = null
  let onClose: SidePanelConfig['onClose'] | null = null

  if (config?.onOpen) {
    onOpen = config.onOpen
  }

  config.onOpen = (sidePanel) => {
    LayerManager.onOpen(sidePanel.getElement())
    PanelManager.add(sidePanel)
    onOpen?.(sidePanel)
  }

  if (config?.onClose) {
    onClose = config.onClose
  }

  config.onClose = (sidePanel) => {
    LayerManager.onClose(sidePanel.getElement())
    PanelManager.remove(sidePanel)
    onClose?.(sidePanel)
  }

  const sidePanel = new SidePanel(element, config)

  if (shouldAttachElementProperty) {
    ElementPropertiesManager.addProperty(element, 'sidePanel', sidePanel)
  }

  return sidePanel
}
